import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const CostForm_FixedCost_Foau_Mutation = graphql(`
  mutation CostForm_FixedCost_Foau(
    $filter: IdFilterInput!
    $update: FixedCostInput!
    $versionData: VersionDataInput
  ) {
    findOneAndUpdateFixedCost(
      filter: $filter
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type FixedCost_Foau_Result = ResultOf<
  typeof CostForm_FixedCost_Foau_Mutation
>;

export const useUpdateFixedCostMutation = () =>
  useGraphQLMutation(CostForm_FixedCost_Foau_Mutation);
